export default {
  "brand.name": "USFansSheet",
  "nav.home": "Inicio",
  "nav.categories": "Categorías",
  "nav.article": "Guías",
  "nav.faq": "FAQ",
  "nav.shoppingGuide": "Guía de compras",
  "nav.guides": "Guías",
  "buttons.buyNow": "Comprar ahora",
  "buttons.usfansSpreadsheet": "USFans Spreadsheet",
  "buttons.viewAll": "Ver todas las categorías",
  "buttons.go": "Ir",
  "categories.shoes": "Zapatos",
  "categories.hoodies": "Sudaderas / Suéteres",
  "categories.tshirts": "Camisetas",
  "categories.jackets": "Chaquetas",
  "categories.pants": "Pantalones / Shorts",
  "categories.headwear": "Gorros",
  "categories.sets": "Conjuntos",
  "categories.underwear": "Ropa interior / Calzoncillos",
  "categories.jersey": "Camiseta deportiva",
  "categories.accessories": "Accesorios",
  "categories.bags": "Bolsos",
  "categories.belts": "Cinturones",
  "categories.perfumes": "Perfumes",
  "categories.other": "Otras cosas",
  "footer.disclaimer": "USFansSheet es un recurso informativo independiente. La información puede cambiar con el tiempo. Verifica siempre de forma independiente la información actual sobre productos, vendedores, envíos, pagos y promociones antes de tomar decisiones.",
  "footer.rights": "Todos los derechos reservados.",
  "footer.explore": "Explorar",
  "footer.categories": "Categorías",
  "footer.resources": "Recursos",
  "footer.backHome": "Volver al inicio",
  "pillar.title": "Guías principales",
  "pillar.subtitle": "Explora nuestras guías detalladas sobre investigación de USFans, QC, envío, seguridad y más.",
  "pillar.readMore": "Leer guía",
  "published": "Publicado",
  "updated": "Actualizado",
  "readingTime": "min de lectura",
  "backHome": "Volver al inicio",
  "breadcrumbHome": "Inicio",
  "breadcrumbCurrent": "Guía",
  "notFound.title": "Guía no encontrada",
  "notFound.back": "Volver al inicio",
  "tag.beginner": "Guía para principiantes",
  "tag.research": "Guía de investigación",
  "tag.qc": "Guía de QC",
  "tag.shipping": "Guía de envío",
  "tag.warehouse": "Guía de almacén",
  "tag.safety": "Guía de seguridad",
  "tag.categories": "Guía de categorías",
  "tag.compare": "Guía de comparación",
  "tag.coupon": "Guía de cupones",
  "tag.seller": "Guía de vendedores",
};